import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import AuthGuard from '../components/AuthGuard';
import { api } from '../lib/api';

export default function InvestmentRefund() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [teamCount, setTeamCount] = useState('');
  const [phone, setPhone] = useState('');
  const [idCard, setIdCard] = useState('');
  const [currency, setCurrency] = useState('CNY');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    api.get('/investment-refund/status').then(({ data }) => {
      if (data.has_applied) {
        navigate('/refund-progress', { replace: true });
      }
    }).catch(() => {});
  }, [navigate]);

  async function handleSubmit() {
    if (submitting) return;
    if (!name.trim() || !idCard.trim()) {
      toast.error('请填写完整信息');
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/investment-refund', {
        name: name.trim(),
        id_card: idCard.trim(),
        phone: phone.trim() || null,
        team_count: teamCount ? parseInt(teamCount) : null,
        currency,
      });
      toast.success('提交成功');
      navigate('/refund-progress', { replace: true });
    } catch (e: any) {
      toast.error(e?.response?.data?.message || '提交失败');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="max-w-md mx-auto min-h-screen bg-[url(/images/bucang_beijing.png)] bg-[length:100%_100%] bg-no-repeat bg-top pt-[380px] pb-[140px]">
      <AuthGuard />

        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 left-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-black/20 text-white"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>

      {/* Content */}
      <div className="px-4 -mt-2 relative z-10">

        {/* Form card */}
        <div className="bg-[url(/images/bucang_kuang.png)] bg-[length:100%_100%] bg-top bg-no-repeat shadow overflow-hidden pt-[50px]">
          <div className="px-4 pb-4 space-y-3">
            {/* 本人姓名 */}
            <div className="flex items-center gap-3">
              <img src={"/images/bucang_xning.png"} alt="" className="w-6 h-6 flex-shrink-0" />
              <span className="text-[#5a3a1a] text-xs font-medium w-16 flex-shrink-0">本人姓名：</span>
              <input
                type="text"
                placeholder="请输入本人姓名"
                value={name}
                onChange={e => setName(e.target.value)}
                className="flex-1 bg-[#e8e0d0] rounded-lg px-3 py-1.5 text-xs text-[#333] outline-none placeholder:text-[#999]"
              />
            </div>

            {/* 团队人数 */}
            <div className="flex items-center gap-3">
              <img src={"/images/bucang_renshu.png"} alt="" className="w-6 h-6 flex-shrink-0" />
              <span className="text-[#5a3a1a] text-xs font-medium w-16 flex-shrink-0">团队人数：</span>
              <input
                type="number"
                placeholder="请输入团队人数"
                value={teamCount}
                onChange={e => setTeamCount(e.target.value)}
                className="flex-1 bg-[#e8e0d0] rounded-lg px-3 py-1.5 text-xs text-[#333] outline-none placeholder:text-[#999]"
              />
            </div>

            {/* 手机号码 */}
              <div className="flex items-center gap-3">
                <img src={"/images/bucang_shouji.png"} alt="" className="w-6 h-6 flex-shrink-0" />
              <span className="text-[#5a3a1a] text-xs  font-medium w-16 flex-shrink-0">手机号码：</span>
              <input
                type="tel"
                placeholder="请输入手机号码"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                className="flex-1 bg-[#e8e0d0] rounded-lg px-3 py-1.5 text-xs text-[#333] outline-none placeholder:text-[#999]"
              />
            </div>

            {/* 证件号码 */}
            <div className="flex items-center gap-3">
              <img src={"/images/bucang_zhnehjian.png"} alt="" className="w-6 h-6 flex-shrink-0" />
              <span className="text-[#5a3a1a] text-xs font-medium w-16 flex-shrink-0">证件号码：</span>
              <input
                type="text"
                placeholder="请输入证件号码"
                value={idCard}
                onChange={e => setIdCard(e.target.value)}
                className="flex-1 bg-[#e8e0d0] rounded-lg px-3 py-1.5 text-xs text-[#333] outline-none placeholder:text-[#999]"
              />
            </div>

            {/* 补偿金额 */}
            <div className="flex items-center gap-3">
              <img src={"/images/bucang_buzhong.png"} alt="" className="w-6 h-6 flex-shrink-0" />
              <span className="text-[#5a3a1a] text-xs font-medium w-16 flex-shrink-0">补偿金额：</span>
              <div className="flex-1 bg-[#e8e0d0] rounded-lg px-3 py-1.5 text-xs text-[#333] font-bold">
                900万
              </div>
            </div>

            {/* 币种 */}
            <div className="flex items-center gap-3">
              <img src={"/images/bucang_zhnehjian.png"} alt="" className="w-6 h-6 flex-shrink-0" />
              <span className="text-[#5a3a1a] text-xs font-medium w-16 flex-shrink-0">币　　种：</span>
              <select
                value={currency}
                onChange={e => setCurrency(e.target.value)}
                className="flex-1 bg-[#e8e0d0] rounded-lg px-3 py-1.5 text-xs text-[#333] outline-none appearance-none"
                style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23666\' stroke-width=\'2\'%3E%3Cpath d=\'M6 9l6 6 6-6\'/%3E%3C/svg%3E")', backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center' }}
              >
                <option value="CNY">人民币</option>
                <option value="USD">美元</option>
              </select>
            </div>
          </div>

          {/* Submit button */}
          <div className="px-4 pb-4">
            <button onClick={handleSubmit} disabled={submitting} className="w-full">
              <img
                src="/images/bucang_liji.png"
                alt="立即提交"
                className={`w-[300px] mx-auto ${submitting ? 'opacity-60' : ''}`}
              />
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
